import { render } from "./ChiTietHoiNghi.vue?vue&type=template&id=64ae12bc&scoped=true&ts=true"
import script from "./ChiTietHoiNghi.vue?vue&type=script&lang=ts"
export * from "./ChiTietHoiNghi.vue?vue&type=script&lang=ts"

import "./ChiTietHoiNghi.vue?vue&type=style&index=0&id=64ae12bc&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/NghienCuuKhoaHoc/NCKH_FontEnd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ae12bc"]])

export default __exports__